<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: "APP",
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽度
      screenHeight: document.body.clientHeight, // 屏幕高度
    }
  },

  computed: {
    ...mapState([
      "routerInfo"
    ])
  },
  created() {
    window.screenWidth = document.body.clientWidth;
    window.screenHeight = document.body.clientHeight;
    this.screenWidth = window.screenWidth;
    this.screenHeight = window.screenHeight;
    this.$store.dispatch("setScreenWidth", this.screenWidth);
    this.$store.dispatch("setScreenHeight", this.screenHeight);
    setTimeout(() => {
      window.screenWidth = document.body.clientWidth;
      window.screenHeight = document.body.clientHeight;
      this.screenWidth = window.screenWidth;
      this.screenHeight = window.screenHeight;
      this.$store.dispatch("setScreenWidth", this.screenWidth);
      this.$store.dispatch("setScreenHeight", this.screenHeight);
    }, 1000)
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
      sessionStorage.removeItem('store')
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
    window.addEventListener('resize', () => {
      window.screenWidth = document.body.clientWidth;
      window.screenHeight = document.body.clientHeight;
      this.screenWidth = window.screenWidth;
      this.screenHeight = window.screenHeight;
      this.$store.dispatch("setScreenWidth", this.screenWidth);
      this.$store.dispatch("setScreenHeight", this.screenHeight);
    })
  },
  mounted() {
    window.screenWidth = document.body.clientWidth;
    window.screenHeight = document.body.clientHeight;
    this.screenWidth = window.screenWidth;
    this.screenHeight = window.screenHeight;
    this.$store.dispatch("setScreenWidth", this.screenWidth);
    this.$store.dispatch("setScreenHeight", this.screenHeight);
    setTimeout(() => {
      window.screenWidth = document.body.clientWidth;
      window.screenHeight = document.body.clientHeight;
      this.screenWidth = window.screenWidth;
      this.screenHeight = window.screenHeight;
      this.$store.dispatch("setScreenWidth", this.screenWidth);
      this.$store.dispatch("setScreenHeight", this.screenHeight);
    }, 500)
  },
  methods: {}
}
</script>
<style lang="scss">
.el-message {

  font-size: 18px;

  .el-message__content {
    font-size: inherit;
  }
}

.ivu-table td, .ivu-table th {
  height: 40px !important;

}

.el-table .el-table__cell {
  padding: 0px !important;
}
.ivu-table-fixed-right.ivu-table-fixed-shadow {
  box-shadow: none !important;
}
.ivu-table-fixed-shadow {
  box-shadow: none !important;
  border-left: 1px solid #e8eaec !important;
}
</style>
<style lang="scss">
#app {
  min-height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-size: 13px;
}

html, body {
  width: 100%;
  height: 100%;
}

/* 滚动条整体样式 */
::-webkit-scrollbar {
  width: 5px;
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 3px;
}

/* 滚动条滑块悬停状态 */
::-webkit-scrollbar-thumb:hover {
  background: #ddd;
}

.el-form-item__label {
  font-weight: bold;
}

.el-tab-pane {
  width: 100%;
}

.ivu-table-wrapper {
  width: 100%;
}
</style>
